"use client";

import { createContext, useContext, useEffect, useState } from "react";
import { OmniSearchModal } from "./modal";

type ContextProps = {
  openSearch: () => void;
  closeSearch: () => void;
};

const OmniSearchContext = createContext<ContextProps>({
  openSearch: () => {},
  closeSearch: () => {},
});

export function OmniSearchProvider({ children }: { children: React.ReactNode }) {
  const [visible, setVisible] = useState(false);

  const openSearch = () => {
    if (visible) return;
    setVisible(true);
  };

  const closeSearch = () => {
    if (!visible) return;
    setVisible(false);
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && (e.key === "k" || e.key === "K")) {
        e.preventDefault();
        openSearch();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <OmniSearchContext.Provider value={{ openSearch, closeSearch }}>
      {children}
      <OmniSearchModal visible={visible} onClose={closeSearch} />
    </OmniSearchContext.Provider>
  );
}

export const useOmniSearch = () => useContext(OmniSearchContext);
